"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M5.4 12c0-3.64 2.96-6.6 6.6-6.6 1.47 0 2.861.473 4.023 1.368L14.49 8.76A4.046 4.046 0 0012 7.914 4.09 4.09 0 007.914 12 4.09 4.09 0 0012 16.086a4.093 4.093 0 003.888-2.829H12v-2.514h6.6V12c0 3.64-2.96 6.6-6.6 6.6-3.64 0-6.6-2.96-6.6-6.6z" }), "Google");
//# sourceMappingURL=Google.js.map